import { ImageUploader } from '@/containers/ClubPlus/CreateTier/phases/Display/ImageUploader'
import { Divider, TextArea } from "@/components/atoms"
import { TextInputField } from '@/components/molecules'
import { useFormContext, Controller } from "react-hook-form"
import { Font } from 'pepsico-ds'
import { useIntl } from 'react-intl'

export const DisplayForm = ({ language }) => {
  const { control } = useFormContext();
  const { formatMessage } = useIntl()

  return (
    <>
      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_HOMEPAGE_TITLE' })}
        </Font>
      </div>
      <div className="flex justify-start w-full gap-6">
        <ImageUploader
          control={control}
          name={`content.${language}.imageTierIcon`}
          label={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_TIER_NAME_LABEL' })}
          helperText={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_TIER_ICON_HELPER_TEXT' })}
        />
        <div>
          <Controller
            name={`content.${language}.tierName`}
            control={control}
            render={({ field }) => (
              <TextInputField
                isDark
                value={field.value || ''}
                updateValue={(value) => field.onChange(value)}
                visible
                uiSchema={{
                  label: `${formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_NAME_LABEL' })}`,
                  placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_NAME_PLACEHOLDER' }),
                  helperText: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_NAME_HELPER_TEXT' }),
                  isDark: true,
                }}
              />
            )}
          />
          <Controller
            name={`content.${language}.displayDescription`}
            control={control}
            render={({ field }) => (
              <TextInputField
                isDark
                value={field.value}
                updateValue={(value) => {
                  if (value) {
                    field.onChange(value)
                  }
                }}
                visible
                uiSchema={{
                  label: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DISPLAY_DESCRIPTION_LABEL' }),
                  placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DISPLAY_DESCRIPTION_PLACEHOLDER' }),
                  helperText: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_HELPER_TEXT' }),
                  isDark: true,
                }}
              />
            )}
          />
        </div>
      </div>
      <Divider />
      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DETAIL_BANNER' })}
        </Font>
      </div>
      <div className="flex justify-start w-full gap-6 tier-display-form">
        <ImageUploader
          control={control}
          name={`content.${language}.bannerImage`}
          label={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_REVIEW_HOMEPAGE_IMAGE' })}
          helperText={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_HOMEPAGE_IMAGE_HELPER_TEXT' })}
        />
        <div className="flex flex-col gap-3">
          <Controller
            name={`content.${language}.bannerHeader`}
            control={control}
            render={({ field }) => (
              <TextArea
                isDark
                value={field.value}
                updateValue={(value) => {
                  if (value) {
                    field.onChange(value)
                  }
                }}
                label={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_BANNER_HEADER_LABEL' })}
                uiSchema={{
                  placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_BANNER_HEADER_PLACEHOLDER' }),
                  helperText: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_TEXTAREA_HELPER_TEXT' }),
                  isDark: true,
                  showToolbar: false,
                }}
              />
            )}
          />
          <Controller
            name={`content.${language}.bannerDescription`}
            control={control}
            render={({ field }) => (
              <TextArea
                isDark
                value={field.value}
                updateValue={(value) => {
                  if (value) {
                    field.onChange(value)
                  }
                }}
                label={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DISPLAY_DESCRIPTION_LABEL' })}
                uiSchema={{
                  placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DISPLAY_DESCRIPTION_PLACEHOLDER' }),
                  helperText: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_HELPER_TEXT' }),
                  isDark: true,
                  showToolbar: false
                }}
              />
            )}
          />
        </div>
      </div>
      <Divider />
      <div className="my-5">
        <Font variant="bold" size="body" textColorClass="text-white">
          {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DETAIL_PAGE' })}
        </Font>
      </div>
      <div className="flex justify-start w-full gap-6 tier-display-form">
        <ImageUploader
          control={control}
          name={`content.${language}.detailsImage`}
          label={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DETAIL_PAGE_IMG' })}
          helperText={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DETAIL_PAGE_IMAGE_HELPER_TEXT' })}
        />
        <div className="flex flex-col gap-3">
          <Controller
            name={`content.${language}.descriptionDetail`}
            control={control}
            render={({ field }) => (
              <TextArea
                isDark
                value={field.value}
                updateValue={(value) => {
                  if (value) {
                    field.onChange(value)
                  }
                }}
                label={`${formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DESCRIPTION_LABEL' })}`}
                uiSchema={{
                  placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_DESCRIPTION_LABEL' }),
                  helperText: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_HELPER_TEXT' }),
                  isDark: true,
                  showToolbar: false
                }}
              />
            )}
          />
          <Controller
            name={`content.${language}.termsAndConditions`}
            control={control}
            render={({ field }) => (
              <TextArea
                isDark
                value={field.value}
                updateValue={(value) => {
                  if (value) {
                    field.onChange(value)
                  }
                }}
                label={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_TERMS_CONDITIONS_LABEL' })}
                uiSchema={{
                  placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_TERMS_CONDITIONS_LABEL' }),
                  helperText: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_FORM_HELPER_TEXT' }),
                  isDark: true,
                  showToolbar: false
                }}
              />
            )}
          />
        </div>
      </div>
      <Divider />
      <div className="pb-28"></div>
    </>
  )
}
